export default "__VITE_ASSET__DWQeXbOu__"